module.exports = __webpack_public_path__ + "37210912b3e4b44eb5dc9f598512d310.png";